import { IParameters } from '@common/services/settings/parameters.interface';

export const AppSettings: IParameters = {
    title: 'Santander',
    storageNS: 'Santander',
    imagesUrl: '/img/catalog/products/',
    imagesCategoriesUrl: 'img/catalog/categories/web/',

    signInSlideShow: [
        {
            image: '/assets/img/slideshow/back.jpg',
            message: '',
            duration: 5000,
            animation: 'fadeIn',
        },
        {
            image: '/assets/img/slideshow/back.jpg',
            message: '',
            duration: 5000,
            animation: 'fadeIn',
        },
        {
            image: '/assets/img/slideshow/back.jpg',
            message: '',
            duration: 5000,
            animation: 'fadeIn',
        },
        {
            image: '/assets/img/slideshow/back.jpg',
            message: '',
            duration: 5000,
            animation: 'fadeIn',
        },
        {
            image: '/assets/img/slideshow/back.jpg',
            message: '',
            duration: 5000,
            animation: 'fadeIn',
        },
    ],

    roles: {
        administrator: {
            rolesUri: 'administrator',
        },
        commercialManager: {
            rolesUri: 'commercial-manager',
        },
        creditSpecialist: {
            rolesUri: 'credit-specialist',
        },
        participant: {
            rolesUri: 'participant',
            slides: [
                {
                    url: '/assets/img/slides/regreso_a_clases.jpg',
                    href: null,
                },
                {
                    url: '/assets/img/slides/certificados_amazon.jpg',
                    href: null,
                },
                {
                    url: '/assets/img/slides/puntos.jpg',
                    href: null,
                },
                {
                    url: '/assets/img/slides/despensa.png',
                    href: null,
                },
                {
                    url: '/assets/img/slides/casa.png',
                    href: null,
                },
                {
                    url: '/assets/img/slides/disfruta-sin-inconvenientes.jpg',
                    href: null,
                },
            ],
        },
    },
};
